// src/redux/metaApi.js
import { apiSlice } from "./apiSlice";

export const metaApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getRentCorp: build.query({
            query: ({ corpName, office_type, biz_number, query }) => ({
                url: "/api/user/meta/v1/rent_corp",
                method: "get",
                params: { corpName, office_type, biz_number, query },
                headers: { token: true },
            }),
        }),
        getFuelList: build.query({
            query: () => ({
                url: "/api/user/meta/v1/fuel",
                method: "get",
                headers: { token: true },
            }),
        }),
        getCarTrim: build.query({
            query: ({ bsNo }) => ({
                url: "/api/user/meta/v1/car_trim",
                method: "get",
                params: { bsNo },
                headers: { token: true },
            }),
        }),
        getCarModelDetail: build.query({
            query: ({ boiNo }) => ({
                url: "/api/user/meta/v1/car_model_detail",
                method: "get",
                params: { boiNo },
                headers: { token: true },
            }),
        }),
        getCarModel: build.query({
            query: ({ bmNo, carGubun }) => ({
                url: "/api/user/meta/v1/car_model",
                method: "get",
                params: { bmNo: bmNo, car_gubun: carGubun },
                headers: { token: true },
            }),
        }),
        getCarManufacturer: build.query({
            query: ({ bmNo = null, cho }) => ({
                url: "/api/user/meta/v1/car_manufacturer",
                method: "get",
                params: { bmNo: bmNo, cho: cho },
                headers: { token: true },
            }),
        }),
        getCarGubun: build.query({
            query: () => ({
                url: "/api/user/meta/v1/car_gubun",
                method: "get",
                headers: { token: true },
            }),
        }),
        getCarClass: build.query({
            query: ({ boNo }) => ({
                url: "/api/user/meta/v1/car_class",
                method: "get",
                params: { boNo },
                headers: { token: true },
            }),
        }),
        getAddressCode: build.query({
            query: ({ take_1_step, take_2_step, parent_b_code }) => ({
                url: "/api/user/meta/v1/address_code",
                method: "get",
                params: { take_1_step, take_2_step, parent_b_code },
                headers: { token: true },
            }),
        }),
        getAddressCode2: build.mutation({
            query: ({ take_1_step, take_2_step, parent_b_code }) => ({
                url: "/api/user/meta/v1/address_code",
                method: "get",
                params: { take_1_step, take_2_step, parent_b_code },
                headers: { token: true },
            }),
        }),
        getInsuranceCorpMeta: build.query({
            query: () => ({
                url: "/api/user/insurance_corp/v1",
                method: "get",
                headers: { token: true },
            }),
        }),
        getRentPriceTable: build.query({
            query: (params) => ({
                url: "/api/user/meta/v1/rent_price_table",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        getRentPriceTableItems: build.query({
            query: (params) => ({
                url: "/api/user/meta/v1/rent_price_table/items",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        getRentPriceTableDetail: build.query({
            query: (rentPriceTableId) => ({
                url: `/api/user/meta/v1/rent_price_table/${rentPriceTableId}`,
                method: "get",
                headers: { token: true },
            }),
        }),
        getBankList: build.query({
            query: () => ({
                url: "/api/user/meta/v1/bank",
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetRentCorpQuery,
    useLazyGetRentCorpQuery,
    useGetFuelListQuery,
    useGetCarTrimQuery,
    useGetCarModelDetailQuery,
    useGetCarModelQuery,
    useGetCarManufacturerQuery,
    useGetCarGubunQuery,
    useGetCarClassQuery,
    useGetAddressCodeQuery,
    useGetAddressCode2Mutation,
    useGetInsuranceCorpMetaQuery,
    useGetRentPriceTableQuery,
    useGetRentPriceTableItemsQuery,
    useLazyGetRentPriceTableItemsQuery,
    useGetRentPriceTableDetailQuery,
    useLazyGetRentPriceTableQuery,
    useLazyGetRentPriceTableDetailQuery,
    useGetBankListQuery,
} = metaApi;
